export default {
	percentages: {
		slightlyTooMany: 15,
		farTooMany: 20,
	},
	cornerstonePercentages: {
		slightlyTooMany: 15,
		farTooMany: 20,
	},
};
